import type { SelectOption } from '@/types/page'

export const USER_STATUS: Record<string, SelectOption> = {
  pending_verification: { value: 'pending_verification', label: '待认证', tone: 'warning' },
  active: { value: 'active', label: '正常', tone: 'success' },
  disabled: { value: 'disabled', label: '已停用', tone: 'danger' },
  cancelled: { value: 'cancelled', label: '已注销', tone: 'neutral' },
}

export const FAMILY_STATUS: Record<string, SelectOption> = {
  active: { value: 'active', label: '正常', tone: 'success' },
  disabled: { value: 'disabled', label: '已停用', tone: 'neutral' },
}

export const FAMILY_RISK: Record<string, SelectOption> = {
  低风险: { value: '低风险', label: '低风险', tone: 'success' },
  中风险: { value: '中风险', label: '中风险', tone: 'warning' },
  高风险: { value: '高风险', label: '高风险', tone: 'danger' },
}

export const REGION_STATUS: Record<string, SelectOption> = {
  active: { value: 'active', label: '启用', tone: 'success' },
  disabled: { value: 'disabled', label: '停用', tone: 'neutral' },
}

export const PLAN_STATUS: Record<string, SelectOption> = {
  active: { value: 'active', label: '执行中', tone: 'success' },
  paused: { value: 'paused', label: '已暂停', tone: 'warning' },
  overdue: { value: 'overdue', label: '已逾期', tone: 'danger' },
  completed: { value: 'completed', label: '已完成', tone: 'neutral' },
}

export const RECORD_STATUS: Record<string, SelectOption> = {
  taken: { value: 'taken', label: '已服药', tone: 'success' },
  overdue: { value: 'overdue', label: '已逾期', tone: 'danger' },
  skipped: { value: 'skipped', label: '已跳过', tone: 'neutral' },
  pending: { value: 'pending', label: '待确认', tone: 'warning' },
}

export const ALERT_STATUS: Record<string, SelectOption> = {
  pending: { value: 'pending', label: '待处理', tone: 'warning' },
  processing: { value: 'processing', label: '处理中', tone: 'info' },
  resolved: { value: 'resolved', label: '已处理', tone: 'success' },
  closed: { value: 'closed', label: '已关闭', tone: 'neutral' },
}

export const RULE_STATUS: Record<string, SelectOption> = {
  active: { value: 'active', label: '启用', tone: 'success' },
  disabled: { value: 'disabled', label: '停用', tone: 'neutral' },
}

export const SEVERITY: Record<string, SelectOption> = {
  低: { value: '低', label: '低', tone: 'success' },
  中: { value: '中', label: '中', tone: 'warning' },
  高: { value: '高', label: '高', tone: 'danger' },
}

export const REPORT_STATUS: Record<string, SelectOption> = {
  generating: { value: 'generating', label: '生成中', tone: 'info' },
  completed: { value: 'completed', label: '已完成', tone: 'success' },
  failed: { value: 'failed', label: '生成失败', tone: 'danger' },
  sent: { value: 'sent', label: '已发送', tone: 'success' },
}

export const DEVICE_STATUS: Record<string, SelectOption> = {
  online: { value: 'online', label: '在线', tone: 'success' },
  offline: { value: 'offline', label: '离线', tone: 'neutral' },
  fault: { value: 'fault', label: '故障', tone: 'danger' },
  unbound: { value: 'unbound', label: '未绑定', tone: 'neutral' },
}

export const DRUG_REVIEW_STATUS: Record<string, SelectOption> = {
  approved: { value: 'approved', label: '已上架', tone: 'success' },
  pending: { value: 'pending', label: '待审核', tone: 'warning' },
  rejected: { value: 'rejected', label: '已驳回', tone: 'danger' },
  offline: { value: 'offline', label: '已下架', tone: 'neutral' },
}

export const MESSAGE_STATUS: Record<string, SelectOption> = {
  draft: { value: 'draft', label: '草稿', tone: 'warning' },
  scheduled: { value: 'scheduled', label: '待发送', tone: 'info' },
  sending: { value: 'sending', label: '发送中', tone: 'info' },
  sent: { value: 'sent', label: '已发送', tone: 'success' },
  cancelled: { value: 'cancelled', label: '已取消', tone: 'neutral' },
  failed: { value: 'failed', label: '发送失败', tone: 'danger' },
}

export const TEMPLATE_STATUS: Record<string, SelectOption> = {
  active: { value: 'active', label: '启用', tone: 'success' },
  disabled: { value: 'disabled', label: '停用', tone: 'neutral' },
}

export const CONTENT_STATUS: Record<string, SelectOption> = {
  online: { value: 'online', label: '已上线', tone: 'success' },
  offline: { value: 'offline', label: '已下线', tone: 'neutral' },
  scheduled: { value: 'scheduled', label: '待上线', tone: 'info' },
  published: { value: 'published', label: '已发布', tone: 'success' },
}

export const MEMBERSHIP_PLAN_STATUS: Record<string, SelectOption> = {
  online: { value: 'online', label: '已上线', tone: 'success' },
  offline: { value: 'offline', label: '已下线', tone: 'neutral' },
}

export const ORDER_STATUS: Record<string, SelectOption> = {
  pending: { value: 'pending', label: '待支付', tone: 'warning' },
  paid: { value: 'paid', label: '已支付', tone: 'success' },
  refund_pending: { value: 'refund_pending', label: '退款审核中', tone: 'warning' },
  refunded: { value: 'refunded', label: '已退款', tone: 'danger' },
  closed: { value: 'closed', label: '已关闭', tone: 'neutral' },
}

export const LINK_STATUS: Record<string, SelectOption> = {
  active: { value: 'active', label: '启用', tone: 'success' },
  disabled: { value: 'disabled', label: '停用', tone: 'neutral' },
}

export const ASSET_STATUS: Record<string, SelectOption> = {
  active: { value: 'active', label: '有效', tone: 'success' },
  archived: { value: 'archived', label: '已归档', tone: 'neutral' },
}

export const TICKET_STATUS: Record<string, SelectOption> = {
  pending: { value: 'pending', label: '待受理', tone: 'warning' },
  assigned: { value: 'assigned', label: '已指派', tone: 'info' },
  processing: { value: 'processing', label: '处理中', tone: 'info' },
  resolved: { value: 'resolved', label: '已解决', tone: 'success' },
  closed: { value: 'closed', label: '已关闭', tone: 'neutral' },
}

export const TICKET_PRIORITY: Record<string, SelectOption> = {
  低: { value: '低', label: '低', tone: 'neutral' },
  中: { value: '中', label: '中', tone: 'info' },
  高: { value: '高', label: '高', tone: 'warning' },
  紧急: { value: '紧急', label: '紧急', tone: 'danger' },
}

export const FEEDBACK_STATUS: Record<string, SelectOption> = {
  pending: { value: 'pending', label: '待处理', tone: 'warning' },
  processing: { value: 'processing', label: '处理中', tone: 'info' },
  replied: { value: 'replied', label: '已回复', tone: 'success' },
  closed: { value: 'closed', label: '已关闭', tone: 'neutral' },
}

export const ADMIN_STATUS: Record<string, SelectOption> = {
  active: { value: 'active', label: '启用', tone: 'success' },
  disabled: { value: 'disabled', label: '停用', tone: 'danger' },
}

export const ROLE_STATUS: Record<string, SelectOption> = {
  active: { value: 'active', label: '启用', tone: 'success' },
  disabled: { value: 'disabled', label: '停用', tone: 'neutral' },
}

export const RESULT_STATUS: Record<string, SelectOption> = {
  成功: { value: '成功', label: '成功', tone: 'success' },
  失败: { value: '失败', label: '失败', tone: 'danger' },
}

export function toOptions(map: Record<string, SelectOption>): SelectOption[] {
  return Object.values(map)
}

export const USER_AGE_OPTIONS: SelectOption[] = [
  { value: 'age_under_45', label: '45岁以下' },
  { value: 'age_45_59', label: '45-59岁' },
  { value: 'age_60_74', label: '60-74岁' },
  { value: 'age_75_plus', label: '75岁及以上' },
]

export const GENDER_OPTIONS: SelectOption[] = [
  { value: 'male', label: '男' },
  { value: 'female', label: '女' },
]

export const FAMILY_TYPE_OPTIONS: SelectOption[] = ['核心家庭', '三代同堂', '夫妻家庭', '独居长者'].map(value => ({ value, label: value }))
export const FAMILY_ROLE_OPTIONS: SelectOption[] = ['本人', '配偶', '子女', '父母', '其他亲属'].map(value => ({ value, label: value }))
export const FREQUENCY_OPTIONS: SelectOption[] = ['每日一次', '每日两次', '每日三次', '隔日一次', '每周三次'].map(value => ({ value, label: value }))
export const TIMING_OPTIONS: SelectOption[] = ['晨起空腹', '早餐后', '午餐后', '晚餐后', '睡前'].map(value => ({ value, label: value }))
export const METRIC_OPTIONS: SelectOption[] = ['血压', '血糖', '心率', '血氧', '体温', '体重'].map(metric => ({ value: metric, label: `${metric}监测` }))
export const CHANNEL_OPTIONS: SelectOption[] = ['站内信', '短信', '微信服务号', '电话'].map(value => ({ value, label: value }))
export const MESSAGE_TYPE_OPTIONS: SelectOption[] = ['健康提醒', '用药提醒', '会员通知', '系统公告', '服务关怀'].map(value => ({ value, label: value }))
export const MEMBER_PERIOD_OPTIONS: SelectOption[] = [
  { value: '1', label: '1个月' },
  { value: '3', label: '3个月' },
  { value: '6', label: '6个月' },
  { value: '12', label: '12个月' },
]
export const DATA_SCOPE_OPTIONS: SelectOption[] = [
  { value: 'all', label: '全部平台数据' },
  { value: 'business', label: '全部业务数据' },
  { value: 'assigned', label: '分配家庭数据' },
  { value: 'catalog', label: '药品主数据' },
  { value: 'review', label: '审核数据' },
  { value: 'support', label: '客服队列' },
  { value: 'device_region', label: '所辖区域设备' },
  { value: 'aggregate', label: '聚合分析' },
  { value: 'audit', label: '审计与运维' },
]
